// extracted by mini-css-extract-plugin
export default {"PizzaList__item":"PizzaList_PizzaList__item__30gzz"};